const PENDING_DRAFT_MARKER = "[[[PENDING DRAFT]]]";
const COMPLETE_DRAFT_MARKER = "[[[COMPLETE DRAFT]]]";
const INCOMPLETE_DRAFT_MARKER = "[[[INCOMPLETE DRAFT]]]";
const NO_PERMISSION_DRAFT_MARKER = "[[[NO PERMISSION DRAFT]]]";

export { COMPLETE_DRAFT_MARKER, INCOMPLETE_DRAFT_MARKER, NO_PERMISSION_DRAFT_MARKER, PENDING_DRAFT_MARKER };
//# sourceMappingURL=filterDiffTags.js.map
